import { Phone, Mail, MapPin } from "lucide-react";
import Seo from "@/components/Seo";
import PageLayout from "@/components/PageLayout";
import PageHero from "@/components/PageHero";
import QuoteForm from "@/components/QuoteForm";
import { PHONE_DISPLAY, PHONE_HREF } from "@/components/Header";

const Contact = () => (
  <PageLayout>
    <Seo
      title="Contact Oz Property Services Co. – Melbourne"
      description="Get in touch with Oz Property Services Co. for a fast, clear quote on your Melbourne property job. Call or send us your details."
      path="/contact"
    />
    <PageHero
      title="Contact Oz Property Services Co."
      subtitle="Get in touch for a fast, clear quote on your property job."
    />
    <section className="bg-white py-14 md:py-20">
      <div className="container max-w-3xl">
        <div className="grid sm:grid-cols-3 gap-6">
          <a href={PHONE_HREF} className="bg-card rounded-2xl p-7 text-center hover:shadow-lg transition-shadow">
            <div className="w-12 h-12 bg-yellow/15 rounded-full flex items-center justify-center mx-auto mb-4">
              <Phone className="w-6 h-6 text-dark" />
            </div>
            <p className="font-bold text-dark mb-1">Call us</p>
            <p className="text-muted-foreground text-sm">{PHONE_DISPLAY}</p>
          </a>
          <a href="mailto:hello@ozpropertyservicesco.com.au" className="bg-card rounded-2xl p-7 text-center hover:shadow-lg transition-shadow">
            <div className="w-12 h-12 bg-yellow/15 rounded-full flex items-center justify-center mx-auto mb-4">
              <Mail className="w-6 h-6 text-dark" />
            </div>
            <p className="font-bold text-dark mb-1">Email</p>
            <p className="text-muted-foreground text-sm break-all">hello@ozpropertyservicesco.com.au</p>
          </a>
          <div className="bg-card rounded-2xl p-7 text-center">
            <div className="w-12 h-12 bg-yellow/15 rounded-full flex items-center justify-center mx-auto mb-4">
              <MapPin className="w-6 h-6 text-dark" />
            </div>
            <p className="font-bold text-dark mb-1">Based in</p>
            <p className="text-muted-foreground text-sm">Melbourne, VIC</p>
          </div>
        </div>
      </div>
    </section>
    <QuoteForm />
  </PageLayout>
);

export default Contact;
